import React from 'react';
import { AlertTriangle, Stars, Coffee, UserPlus } from 'lucide-react';
import '../EvaluationDesign.css';

/**
 * Skill4Box Component
 * Original SIRH Professional version
 */
const Skill4Box = ({ data, compact = false }) => {
    if (!data || data.length === 0) {
        return (
            <div className="eval-empty">
                <p>Aucune donnée disponible pour générer la 4-Box.</p>
            </div>
        );
    }

    const boxes = {
        urgency: {
            title: "Urgence / Formation",
            subtitle: "Haut requis, Basse maîtrise",
            icon: <AlertTriangle size={18} className="eval-badge-red" />,
            items: []
        },
        experts: {
            title: "Atouts / Experts",
            subtitle: "Haut requis, Haute maîtrise",
            icon: <Stars size={18} className="eval-badge-blue" />,
            items: []
        },
        secondary: {
            title: "Secondaire",
            subtitle: "Bas requis, Basse maîtrise",
            icon: <Coffee size={18} className="eval-badge-grey" />,
            items: []
        },
        potential: {
            title: "Potentiel / Ressource",
            subtitle: "Bas requis, Haute maîtrise",
            icon: <UserPlus size={18} className="eval-badge-green" />,
            items: []
        }
    };

    data.forEach(item => {
        const isHighMastery = (item.obtenu || 0) >= 3;
        const isHighRequis = (item.requis || 0) >= 3;

        if (isHighRequis && !isHighMastery) {
            boxes.urgency.items.push(item);
        } else if (isHighRequis && isHighMastery) {
            boxes.experts.items.push(item);
        } else if (!isHighRequis && !isHighMastery) {
            boxes.secondary.items.push(item);
        } else {
            boxes.potential.items.push(item);
        }
    });

    return (
        <div className="eval-4box-container">
            <div className="eval-4box-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: compact ? '10px' : '16px', marginTop: compact ? '8px' : '20px' }}>
                <Box quadrant={boxes.urgency} type="urgency" compact={compact} />
                <Box quadrant={boxes.experts} type="experts" compact={compact} />
                <Box quadrant={boxes.secondary} type="secondary" compact={compact} />
                <Box quadrant={boxes.potential} type="potential" compact={compact} />
            </div>
        </div>
    );
};

const Box = ({ quadrant, type, compact }) => (
    <div className={`eval-card eval-4box-quadrant q-${type}`} style={{ minHeight: compact ? '120px' : '180px', display: 'flex', flexDirection: 'column' }}>
        <div className="eval-section-title" style={{ borderBottom: '1px solid #f1f5f9', paddingBottom: compact ? '6px' : '8px', marginBottom: compact ? '8px' : '12px' }}>
            {React.cloneElement(quadrant.icon, { size: compact ? 14 : 18 })}
            <div style={{ flex: 1 }}>
                <div>{quadrant.title}</div>
                <div style={{ fontSize: compact ? '9px' : '10px', color: '#94a3b8', fontWeight: 400 }}>{quadrant.subtitle}</div>
            </div>
            <span className="eval-badge eval-badge-grey">{quadrant.items.length}</span>
        </div>
        <div style={{ flex: 1 }}>
            {quadrant.items.length > 0 ? (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: compact ? '4px' : '6px' }}>
                    {quadrant.items.map((item, idx) => (
                        <span key={idx} className="eval-badge eval-badge-grey" style={{ textTransform: 'none' }}>
                            {item.skill}
                        </span>
                    ))}
                </div>
            ) : (
                <div style={{ fontSize: '12px', color: '#cbd5e1', textAlign: 'center', marginTop: '20px' }}>Vide</div>
            )}
        </div>
    </div>
);

export default Skill4Box;
